import { FormattedMessage } from 'react-intl';
import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { download } from '@cld/file-download';
import Button from '@cld/button';
import theme from '@cld/theme-helper';
import { usePhone } from '@cld/style-utils';
import Icon from '@cld/icon';
import Tooltip from '@cld/tooltip';
import { typography } from '@cld/typography';
import { messages } from '../../i18n';

export const IconWrapper = styled.div`
  width: 13px;
  height: 13px;
  margin-right: 10px;
  flex-shrink: 0;
  transition: transform 0.3s ease-in-out;
  transform: ${(p) => (p.open ? 'rotate(0deg)' : 'rotate(-90deg)')};
  transform-origin: center;
`;

export const Root = styled('div')`
  display: flex;
  flex-shrink: 0; // Fix Safari bug
  cursor: pointer;
  align-items: center;

  ${Button} {
    margin-left: ${theme`spacing.xs`};
  }
`;

export const Title = styled.span`
  overflow: hidden;
  display: inline-flex;
  ${typography.md.highContrast};
`;

const Count = styled.span`
  flex-shrink: 0;
  margin-left: ${theme`spacing.xs`};
  ${typography.md.highContrast};
`;

const Spacer = styled.div`
  flex-grow: 1;
`;

const StyledButton = styled(Button)`
  ${({ visible }) =>
    !visible &&
    css`
      visibility: hidden;
    `};
`;

export const CollectionHeaderItem = ({ title, count, open, downloadLink, ...rest }) => {
  let isPhone = usePhone();

  const downloadCollection = (event) => {
    event.stopPropagation(); // do not collapse collection
    download(downloadLink);
  };

  return (
    <Root open={open} {...rest}>
      <IconWrapper open={open}>
        <Icon name="arrowDropDown" fill="#5A616A" />
      </IconWrapper>
      <Title>
        <Tooltip maxWidth="lg" placement="bottomRight" title={title}>
          <Tooltip.OverflowTrigger>{title}</Tooltip.OverflowTrigger>
        </Tooltip>
      </Title>
      <Count>({count})</Count>
      {downloadLink && (
        <>
          <Spacer />
          <StyledButton visible={open} onClick={downloadCollection}>
            <Icon name="fileDownload" />
            {!isPhone && <FormattedMessage {...messages.collectionDownload} />}
          </StyledButton>
        </>
      )}
    </Root>
  );
};

CollectionHeaderItem.propTypes = {
  title: PropTypes.node,
  count: PropTypes.number,
  downloadLink: PropTypes.string,
  open: PropTypes.bool,
};

CollectionHeaderItem.defaultProps = {
  open: true,
};
